<mat-toolbar color="accent">
  {{ request.subscription ? 'Edit' : 'Add' }} Stripe Subscription
</mat-toolbar>

<mat-tab-group class="block min-w-[32rem]" mat-stretch-tabs="false">
  <mat-tab label="Subscription">
    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-dialog-content class="text-black">
        <div class="flex flex-col gap-1">
          <mat-form-field>
            <mat-label>Customer Id</mat-label>
            <input
              matInput
              formControlName="customerId"
              placeholder="cus_xxxxxxxxxxxx"
            />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Subscription Id</mat-label>
            <input
              matInput
              formControlName="subscriptionId"
              placeholder="sub_xxxxxxxxxxxxxxxxxxxxxxxx"
            />
          </mat-form-field>

          <mat-form-field floatLabel="always">
            <mat-label>Practices</mat-label>
            <mat-select
              multiple
              formControlName="practiceRefs"
              placeholder="Not Practice Specific"
              [compareWith]="isSameRef"
            >
              @for (option of practiceOptions(); track option.value.path) {
                <mat-option [value]="option.value">{{
                  option.label
                }}</mat-option>
              }
            </mat-select>
            <button
              matSuffix
              mat-icon-button
              [disabled]="!form.value.practiceRefs.length"
              (click)="clearPracticeRefs($event)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-slide-toggle formControlName="meteredBillingEnabled">
            <div class="flex items-center gap-2">
              <span>SMS Credits Enabled</span>
              <mat-icon
                matTooltip="This will allow us to charge for SMS Credits on Marketing Campaigns."
              >
                info
              </mat-icon>
            </div>
          </mat-slide-toggle>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions>
        <button type="button" mat-stroked-button mat-dialog-close>
          Cancel
        </button>
        <button
          type="submit"
          mat-flat-button
          color="primary"
          [disabled]="isDisabled$ | async"
        >
          Save
        </button>
      </mat-dialog-actions>
    </form>
  </mat-tab>

  <mat-tab label="Add-on Overrides" [disabled]="!request.subscription">
    @if (liveSubscription(); as subscription) {
      <div class="px-6 py-4">
        <p class="mb-4">
          Each override saves immediately. Cancel and Save on the Subscription
          tab apply only to subscription details.
        </p>
        <pr-add-on-override-section [subscription]="subscription" />
        <mat-dialog-actions>
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="done()"
          >
            Done
          </button>
        </mat-dialog-actions>
      </div>
    }
  </mat-tab>
</mat-tab-group>
